/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MergeStatusBypassAvailable({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><mask id="MergeStatusBypassAvailable_svg__a" width={16} height={16} x={0} y={0} maskUnits="userSpaceOnUse" style={{
      maskType: "luminance"
    }}><path fill="#fff" d="M16 0H0v16h16z" /><path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M8.442 10.198 10.64 8 8.442 5.802M5.36 10.198 7.558 8 5.36 5.802" /></mask><g mask="url(#MergeStatusBypassAvailable_svg__a)"><circle cx={8} cy={8} r={8} fill="currentColor" /></g></svg>;
}
;